import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';
import TextareaAutosize from 'vue-textarea-autosize'
import VueFuse from 'vue-fuse'
import VuejsDialog from 'vuejs-dialog';
import VueObserveVisibility from 'vue-observe-visibility'
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import FlashMessage from '@smartweb/vue-flash-message';
import VueSocialSharing from 'vue-social-sharing';
import VueClipboard from 'vue-clipboard2';
import vuescroll from 'vuescroll/dist/vuescroll-native';
import Loading from 'vue-loading-overlay';
import vueDebounce from 'vue-debounce';
import InfiniteLoading from "vue-infinite-loading";

// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

window.Vue = Vue;
window.axios = axios;

Vue.use(VueRouter);
Vue.use(TextareaAutosize);
Vue.use(VueFuse);
Vue.use(VuejsDialog);
Vue.use(VueObserveVisibility);
Vue.use(FlashMessage);
Vue.use(VueSocialSharing);
Vue.use(VueClipboard);
Vue.use(vuescroll);
Vue.use(Loading);
Vue.use(vueDebounce);
Vue.use(InfiniteLoading, {
    props: {
        spinner: 'default',
        /* other props need to configure */
    },
    system: {
        throttleLimit: 5000,
        /* other settings need to configure */
    }
});

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Set up CSRF token for Laravel
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
